<app-admin-header [header]="header"></app-admin-header>

<div class="guide-container" style="min-height: calc(100vh - 200px);">
  <div class="guide-wrapper">
    <p-card *ngFor="let item of assets" class="guide-card" (click)="open(item)">
      <div class="card-content">
        <div class="icon-wrapper">
          <i class="pi lg-icon" [ngClass]="item.type === 'video' ? 'pi-video' : 'pi-file-word'"></i>
        </div>
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
        <div class="action-hint">
          <i class="pi pi-external-link"></i>
          <span>انقر للعرض</span>
        </div>
      </div>
    </p-card>
  </div>

  <p-dialog 
    [(visible)]="showModal" 
    [modal]="true" 
    [closable]="true"
    [dismissableMask]="true"
    styleClass="custom-dialog"
    [style]="{width:'80vw', maxWidth: '1000px'}" 
    (onHide)="close()">
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <i class="pi" [ngClass]="selected?.type === 'video' ? 'pi-video' : 'pi-file-word'"></i>
        <h3>{{ selected?.title }}</h3>
      </div>
    </ng-template>

    <ng-container *ngIf="selected">
      <div class="dialog-content">
        <video *ngIf="selected.type === 'video'" controls autoplay class="guide-video">
          <source [src]="selected.url" type="video/mp4" />
        </video>

        <div *ngIf="selected.type === 'doc'" class="doc-preview">
          <div class="doc-icon-large">
            <i class="pi pi-file-word"></i>
          </div>
          <p class="doc-description">{{ selected.description }}</p>
          <a [href]="selected.url" download class="doc-download-btn">
            <i class="pi pi-download"></i>
            تنزيل الدليل
          </a>
        </div>
      </div>
    </ng-container>
  </p-dialog>
</div>

<app-footer></app-footer>